import { useToast, useToastError } from "@/components/ui/use-toast";
import { useTeams } from "@/contexts/teams-provider";
import { useApi } from "@/hooks/useApi";
import { useTranslation } from "@/hooks/useTranslation";
import type { TeamLLMDTO } from "@shaarp/common";

export function useLLMPermissions() {
  const toastError = useToastError();
  const api = useApi();
  const { toast } = useToast();
  const { apiFetchTeamLLM } = useTeams();
  const { t } = useTranslation();

  const saveLLMConfig = async (updatedLLM: TeamLLMDTO) => {
    try {
      await api.post<TeamLLMDTO>("/my/team/llm", {
        llm: updatedLLM,
      });

      await apiFetchTeamLLM();

      toast({
        variant: "default",
        title: t("team.components.llmPermissions.toast.success.title"),
        description: t(
          "team.components.llmPermissions.toast.success.description"
        ),
      });
    } catch (error) {
      toastError();
    }
  };

  const updateAvailability = (llm: TeamLLMDTO, available: boolean) => {
    const updatedLLM = { ...llm, available };
    saveLLMConfig(updatedLLM);
  };

  const setAsDefault = (llm: TeamLLMDTO) => {
    const updatedLLM = { ...llm, default: true };
    saveLLMConfig(updatedLLM);
  };

  return {
    updateAvailability,
    setAsDefault,
  };
}
